import { Box, makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { useRouteMatch } from "react-router-dom";
import RouteTabWrapper from "../../Components/RouteTabWrapper";
import TabPageHeader from "../../Components/TabPageHeader";
import itemActions from "../../Stores/Items/actions";
import roleActions from "../../Stores/Roles/actions";

const { openItemsAddModal } = itemActions;
const { openRolesAddModal } = roleActions;

const useStyles = makeStyles((theme) => ({
  mainContent: theme.mainContent,
}));

const RolesAndItemsTabs = ({ children }) => {
  const classes = useStyles();
  const isRolesActive = useRouteMatch("/d/roles")?.isExact;
  return (
    <Box width="100%">
      {isRolesActive ? (
        <TabPageHeader
          style={{ marginLeft: "1rem" }}
          TabTitle="Roles"
          // entriesCount={lists?.length}
          // isLoading={isListLoading}
          // title="List Options"
          // actions={
          //   <IsAuthorised currentItem="ROLE" requiredPermission="WRITE">
          //     <Button
          //       variant="contained"
          //       disabled={isRolesLoading}
          //       color="primary"
          //       endIcon={<AddIcon />}
          //       onClick={openRoleAddModal}
          //     >
          //       Add role
          //     </Button>
          //   </IsAuthorised>
          // }
        />
      ) : (
        <TabPageHeader
          TabTitle="Items"
          // entriesCount={items?.length}
          // isLoading={isItemsLoading}
          // title="Items"
          // actions={
          //   <IsAuthorised currentItem="ROLE" requiredPermission="WRITE">
          //     <Button
          //       variant="contained"
          //       disabled={isItemsLoading}
          //       color="primary"
          //       endIcon={<AddIcon />}
          //       onClick={openItemAddModal}
          //     >
          //       Add item
          //     </Button>
          //   </IsAuthorised>
          // }
        />
      )}
      <RouteTabWrapper
        value={isRolesActive ? 0 : 1}
        tabs={[
          {
            label: "Roles",
            path: "/d/roles",
          },
          {
            label: "Items",
            path: "/d/roles/items",
          },
        ]}
      >
        {children}
      </RouteTabWrapper>
    </Box>
  );
};
RolesAndItemsTabs.propTypes = {
  roles: PropTypes.array,
  openRoleAddModal: PropTypes.func.isRequired,
  items: PropTypes.array,
  openItemAddModal: PropTypes.func.isRequired,
  children: PropTypes.node,
  isItemsLoading: PropTypes.bool,
  isRolesLoading: PropTypes.bool,
};

const mapStateToProps = ({ ItemReducer, RoleReducer }) => ({
  roles: RoleReducer.roles,
  isRolesLoading: RoleReducer.isRolesLoading,
  items: ItemReducer.items,
  isItemsLoading: ItemReducer.isItemsLoading,
});

function mapDispatchToProps(dispatch) {
  return {
    openRoleAddModal: () => dispatch(openRolesAddModal()),
    openItemAddModal: () => dispatch(openItemsAddModal()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RolesAndItemsTabs);
